import { render, staticRenderFns } from "./DiscountHistory.vue?vue&type=template&id=683655f8&scoped=true&"
import script from "./DiscountHistory.vue?vue&type=script&lang=ts&"
export * from "./DiscountHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683655f8",
  null
  
)

export default component.exports